module.exports = __webpack_public_path__ + "images/tour/activity_all_children-69965359de9b421f77186e02c4b683a3.gif";